<template>
    <v-img
        class="login-v-img-container"
        :src="$root.getSrc('default/drop/auth-bg.svg')">
        <div class="px-12">
            <div>
                <div class="d-flex">
                    <AuthPicItem
                        class="col-md-6 mt-10"
                        :title="'34+'"
                        :description="'products all stocked and printed in-house'"
                    />
                    <AuthPicItem
                        class="col-md-6 mt-10"
                        :title="'Unlimited'"
                        :description="'possibilities with our easy to use product designer'"
                    />
                </div>
                <div class="d-flex">
                    <AuthPicItem
                        class="col-md-6 mt-10"
                        :title="'Shipping'"
                        :description="'fast and tracked with our shipping partner Aus Post'"
                    />
                    <AuthPicItem
                        class="col-md-6 mt-10"
                        :title="'Support team'"
                        :description="'ready to help make your dreams a reality'"
                    />
                </div>
            </div>
        </div>
    </v-img>
</template>
<script>
import AuthPicItem from '@/components/auth-pic-item.vue'
export default {
    components: {
        AuthPicItem
    }
}
</script>
